import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../common/session/session.service';

@Injectable({
  providedIn: 'root'
})
export class BrandsService {

  constructor(private http: HttpClient, private sessionService: SessionService) { }

  getBrands(dataIn) {

    let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.BRANDS.GET_BRANDS + '/' + eventData.id + '/brands';

    return this.http.get(url, dataIn);
  }

}

